import Input from '@/components/form/Input';

const FormGeneral = () => {
  return (
    <>
      <Input
        name="name"
        label="Name"
        placeholder="eg. PST (BC)"
        autoComplete="off"
        description="The name of the tax rate - must be unique."
      />
      <Input
        name="label"
        label="Label"
        placeholder="eg. PST"
        autoComplete="off"
        description="The label of the tax (what is displayed on the order). "
      />
      <Input
        name="rate"
        label="Rate"
        placeholder="eg. 7.5"
        autoComplete="off"
      />
    </>
  );
};

export default FormGeneral;
